import { render, staticRenderFns } from "./ThemesModal.vue?vue&type=template&id=6f56da08"
import script from "./ThemesModal.vue?vue&type=script&lang=js"
export * from "./ThemesModal.vue?vue&type=script&lang=js"
import style0 from "./ThemesModal.vue?vue&type=style&index=0&id=6f56da08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports